var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicOffMd = function SvgMicOffMd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7 10V6a4.95 4.95 0 0 1 5-5v0a4.95 4.95 0 0 1 5 5M7 23h10M12 19v4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17 7V6A5 5 0 0 0 7 6v4a4.93 4.93 0 0 0 2.615 4.385M13.484 14.758a4.88 4.88 0 0 0 3.274-3.274M3 10a8.96 8.96 0 0 0 3.711 7.289M9.577 18.665a9.07 9.07 0 0 0 5.873-.34A8.96 8.96 0 0 0 21 10M3 21 21 3"
  })));
};
export default SvgMicOffMd;